import React, { useState } from "react";
import CustomerDetailTransactionList from "./CustomerDetailTransactionList";
import DownloadTransactionPDF from "../../Table/DownloadTransactionsTable";

function CustomerDetailTransactionsSection({ data }) {
  const [tab, setTab] = useState("all");

  const tabs = [
    {
      label: "All",
      code: "all",
    },
    {
      label: "Wallet",
      code: "wallet",
    },
  ];

  return (
    <div className="w-full flex p-4 flex-col">
      <div className="w-full flex items-center gap-2 flex-wrap">
        {tabs?.map((item, itemIndex) => {
          const isSelected = tab === item.code;
          return (
            <button
              key={itemIndex}
              className={`h-12 w-36 rounded-md flex items-center justify-center text-sm font-semibold ${
                isSelected
                  ? "text-white bg-[#4E5662]"
                  : "text-[#6D7C94] bg-[#F8F8F8]"
              }`}
              onClick={() => setTab(item.code)}
            >
              {item.label}
            </button>
          );
        })}
        <div className="flex flex-1"></div>
        <DownloadTransactionPDF data={data} />
      </div>
      <div className="w-full mt-2">
        <CustomerDetailTransactionList tab={tab} data={data} />
      </div>
    </div>
  );
}

export default CustomerDetailTransactionsSection;
